<template>
    <div class="apprentice-simple-card parent-page-wrapper">
        <!--        Wellicht willen we hier een preview van de huidige page.-->

        <div class="info-text"><b>Geef jouw (klein)kind een persoonlijke felicitatie in het jaarboek!</b><br/><br/>
Volg deze eenvoudige stappen om een mooie boodschap toe te voegen:<br/>
<ul><li>Klik op de knop 'Bewerken' om de felicitatiepagina voor jouw (klein)kind te openen. Je ziet een pagina die ongeveer 1/9 of 1/12 van een echte pagina in het jaarboek beslaat.</li>
<li>Voeg tekst, foto's en een achtergrondkleur toe om de felicitatie persoonlijk te maken.</li>
<li>Als je klaar bent, vul dan de naam van jouw (klein)kind en je eigen naam in om de felicitatie af te ronden.</li></ul></div>

        <div class="student-credentials">
            <b-alert
                class="alert-dismissable"
                v-if="isDeadlineExpired && !parentPage?.finished_at"
                variant="danger"
                show>
                De deadline is verstreken, je kunt de felicitatie en gegevens niet meer aanpassen.
            </b-alert>

            <b-alert
                class="alert-dismissable"
                v-if="parentPage?.finished_at"
                variant="success"
                show>
                {{ $t('magazine.parent_page.finished') }}
            </b-alert>

            <div v-if="!parentPage?.finished_at">
                <b-form-group
                    :label="$t('magazine.name_student')"
                    label-for="name-student">
                    <b-form-input
                        id="name-student"
                        v-model="name_student"
                        :disabled="!editable"
                        required
                        :placeholder="$t('magazine.name_student')">
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.name_parent')"
                    label-for="name-parent">
                    <b-form-input
                        id="name-parent"
                        v-model="name_parent"
                        :disabled="!editable"
                        required
                        :placeholder="$t('magazine.name_parent')"></b-form-input>
                </b-form-group>

                <div class="actions">
                    <b-button
                        class="btn-save"
                        v-if="editable"
                        variant="primary"
                        @click="save">
                        {{ $t('common.save') }}
                    </b-button>

                    <b-button
                        class="btn-checked btn-finish"
                        v-if="editable"
                        variant="success"
                        @click="finish">
                        {{ $t('magazine.congratulations_page.finish_button') }}
                    </b-button>
                </div>
            </div>
        </div>

        <div class="magazine-page">
            <design-2021-magazine-parent-page-page-component
                v-if="parentPage"
                :page-in="parentPage.page"
                :editable="editable"
                :magazine-in="magazineIn">
            </design-2021-magazine-parent-page-page-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-parent-page-component',
    props: {
        magazineIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            name_student: null,
            name_parent: null,
            parentPage: null,
        };
    },
    mounted() {
        //to deter parents from spamming the whole thing, and also maintaining the possibility to edit their page later, we design it so that there's only one page per browser.
        let parentPageKey = localStorage.getItem('parentPageKey');

        if (!parentPageKey) {
            const array = new Uint32Array(4);
            window.crypto.getRandomValues(array);
            const parentPageKey = Array.from(array, (byte) => byte.toString(16).padStart(8, '0')).join('');
            localStorage.setItem('parentPageKey', parentPageKey);
        }

        let data = {
            parent_page_key: localStorage.getItem('parentPageKey'),
        };

        this.axios.post(this.routes.getMagazineParentPage(this.magazineIn.id, this.magazineIn.uuid), data).then(
            (response) => {
                this.parentPage = response.data;
                this.name_student = response.data.name_student;
                this.name_parent = response.data.name_parent;
            },
            (error) => {
                this.alert.ajaxError(error);
            },
        );

        const mainTitleEl = document.querySelector('.page-title .title');
        const subTitle = document.createElement('span');
        subTitle.classList.add('sub-title');
        subTitle.innerHTML = `${this.magazineIn.school.name}`;

        if (mainTitleEl) {
            mainTitleEl.parentNode.appendChild(subTitle);
        }
    },
    computed: {
        deadline() {
            return new Date(this.magazineIn.parent_page_deadline);
        },
        isDeadlineExpired() {
            return this.deadline < new Date();
        },
        editable() {
            return !this.isDeadlineExpired && !this.parentPage?.finished_at;
        },
    },
    methods: {
        save() {
            let data = {
                parent_page_key: localStorage.getItem('parentPageKey'),
                name_student: this.name_student,
                name_parent: this.name_parent,
            };

            this.axios.post(this.routes.magazineParentPageUpdate(this.magazineIn.id, this.magazineIn.uuid), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        finish() {
            this.alert
                .confirm(
                    this.$t('magazine.congratulations_page.order_confirm.title'),
                    this.$t('magazine.congratulations_page.order_confirm.text'),
                    this.$t('magazine.congratulations_page.order_confirm.yes_button_text'),
                )
                .then((confirm) => {
                    if (confirm) {
                        let data = {
                            parent_page_key: localStorage.getItem('parentPageKey'),
                        };

                        this.axios
                            .post(
                                this.routes.magazineParentPageFinalize(this.magazineIn.id, this.magazineIn.uuid),
                                data,
                            )
                            .then(
                                (response) => {
                                    this.alert.success();
                                    location.reload();
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                },
                            );

                        // Todo: @Hans M. Finalize order, from this point forward parents can't make any changes and url may as wel be deleted.
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.parent-page-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: $grid-gutter-width 5.625rem;
}

.magazine-page {
    width: 100%;
    height: auto;
    max-width: 500px;
    order: 1;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.info-text {
    margin-bottom: $grid-gutter-width;
    flex: 1 0 100%;
    order: 0;
}

.student-credentials {
    flex: 1 0;
    order: 2;
}

.actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: map-get($grid-gutter-spacing, 'fifteen');
    margin-top: map-get($grid-gutter-spacing, 'forty-two');

    button {
        line-height: 1;
        width: 100%;
    }

    .btn-order-page {
        color: $white;
    }
}
.alert-dismissable {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .actions {
        button {
            width: auto;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .magazine-page {
        max-width: 50%;
        order: 2;
    }

    .student-credentials {
        flex: 0 0 calc(50% - 90px);
        order: 1;
    }

    .actions {
        button {
            width: 100%;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .student-credentials {
        flex: 0 0 450px;

        .form-group {
            max-width: 550px;
        }
    }

    .actions {
        button {
            width: auto;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xxl')) {
    .magazine-page {
        max-width: 550px;
    }

    .student-credentials {
        flex: 0 0 700px;
    }
}
</style>
